import PageShell from "@/components/layout/PageShell";
import RegulatorsSection from "@/components/RegulatorsSection";

export default function MasterRegulatorsPage() {
  return (
    <PageShell
      title="Regulators"
      subtitle="Government / bank / regulatory authorities · auto-flags priority parcels on inward"
      overline="Master · Regulators"
    >
      <RegulatorsSection />
    </PageShell>
  );
}
